export default function(vueInstance) {
  if (vueInstance.$store.state.Delegation.transportTypesFromOrder.length > 0 && vueInstance.contextTransportType !== null) {
    if (!vueInstance.$store.state.Delegation.transportTypesFromOrder.includes(vueInstance.contextTransportType)) {
      return vueInstance.$t("delegation.form.differentTransportHint");
    }
  }
  return null;
}
